import { applyMiddleware, combineReducers, createStore } from "redux";
import { thunk } from "redux-thunk";

import MasterApiReducer from "./reducer/masterApiReducer";
import CompanyApiReducer from "./reducer/companyApiReducer";
import LeaveApiReducer from "./reducer/leaveApiReducer";
import AttendanceApiReducer from "./reducer/AttendenceApiReducer";
import PaySlipsApiReducer from "./reducer/payrollApiReducer";
import CompanyHolidayApiReducer from "./reducer/HolidayApiReducer";
import AuthApiReducer from "./reducer/AuthApiReducer";
import EmployerApiReducer from "./reducer/EmployerApiReducer"
import ProjectApiReducer from "./reducer/ProjectApiReducer";
import TaskApiReducer from "./reducer/TaskApiReducer";
import EmployeeProfileApiReducer from "./reducer/EmployeeProfileReducer";
import ReportApiReducer from "./reducer/ReportApiReducer";
import TaxSlabApiReducer from "./reducer/TaxSlabApiReducer";
import AppraisalApiReducer from "./reducer/AppraisalApiReducer";
import ContractApiReducer from "./reducer/ContractApiReducer";
import EmployeeTaxApiReducer from "./reducer/EmployeeTaxSlabApiReducer";
import DocumentApiReducer from "./reducer/DocumentApiReducer";
const appReducer = combineReducers({
  auth: AuthApiReducer,
  master: MasterApiReducer,
  company: CompanyApiReducer,
  leave: LeaveApiReducer,
  TimeAttendance: AttendanceApiReducer,
  payslip: PaySlipsApiReducer,
  employer_holidays: CompanyHolidayApiReducer,
  employer: EmployerApiReducer,
  project : ProjectApiReducer,
  task: TaskApiReducer,
  employeeProfile:EmployeeProfileApiReducer,
  report:ReportApiReducer,
  taxslab: TaxSlabApiReducer,
  apprisalcycle: AppraisalApiReducer,
  contracts: ContractApiReducer,
  emp_tax : EmployeeTaxApiReducer,
  document : DocumentApiReducer
});
const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;
